import React from 'react';
import { withRouter } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { ContainerBox, Table, ModalFooter } from 'components';
import { MODE, MODAL_ID, DATE_FORMAT, NO_DATE, EMPTY_FORMAT_CELL } from '../../core/utils/constants';
import moment from 'moment';
import BaseComponent from '../BaseComponent';
import './style.scss';

const TABLE_ROW_WIDTH_MODEL = {
  NO: "6%",
  MODEL_TYPE: "14%",
  MODEL_NAME: "25%",
  SIZE: "15%",
  CREATED_BY: "15%",
  UPDATED_DATE: "15%",
  REMOVE: "5%",
};

@inject('commonStore', 'modalStore')
@observer
class ScreenIndividualModel extends BaseComponent {
  executeLogicAfterRender = () => {
    this.props.commonStore.individualModelStore.clean();
    this.props.commonStore.individualModelStore.getModels();
  }

  executeLogicBeforeOutComponent = () => {
    this.props.commonStore.individualModelStore.clean();
  }

  onCancelUpdate = (userId, userStatus) => {
    this.closeModal();
  };

  onConfirmDeleteById = (id) => {
    this.props.commonStore.individualModelStore.deleteModel(id);
    this.closeModal();
  }

  openComfirmModal = (id) => {
    const { modalStore, t } = this.props;
    modalStore.show({
      id: MODAL_ID.REMOVE,
      isOpen: true,
      header: t('definition.remove_confirm'),
      onCancel: this.closeModal,
      children: (
        <div className="text-c">
          <div key={"modal-body"} className="modal-body">
            <span>{t('individual_model_mng.remove_confirm_msg')}</span>
          </div>
          <ModalFooter key={"modal-footer"}
            saveButtonText={t('individual_model_mng.remove')}
            onConfirm={() => this.onConfirmDeleteById(id)}
            cancelButtonText={t('definition.cancel')}
            onCancel={this.closeModal}
            saveButtonClass="btn-primary"
          />
        </div>
      ),
      type: 'small'
    });
  };

  closeModal = () => {
    const { modalStore } = this.props;
    modalStore.hideAll();
  };

  onFetch = (tableData) => {
    this.props.commonStore.individualModelStore.updatePagingFiler(tableData);
    this.props.commonStore.individualModelStore.getModels();
  };

  render() {
    const { t, commonStore: { individualModelStore: { models, paging } } } = this.props;
    const columns = [
      {
        Header: t("individual_model_mng.no"),
        disableSortBy: true,
        width: TABLE_ROW_WIDTH_MODEL.NO,
        Cell: ({ initialState, row }) => <div style={{ textAlign: "center" }}>{
          initialState?.initialTableState?.pageSize *
          initialState?.initialTableState?.pageIndex +
          row.index +
          1
        }</div>
        ,
      },
      {
        Header: t('individual_model_mng.model_type'),
        accessor: 'modelType',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.modelType === 0 ?
                t('individual_model_mng.model_type_print') :
                original.modelType === 1 ?
                  t('individual_model_mng.model_type_manual') :
                  "-"}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_MODEL.MODEL_TYPE
      },
      {
        Header: t('individual_model_mng.model_name'),
        accessor: 'modelName',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.modelName}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_MODEL.MODEL_NAME
      },
      {
        Header: t('individual_model_mng.model_size'),
        accessor: 'fileSize',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.fileSize}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_MODEL.SIZE
      },
      {
        Header: t('individual_model_mng.created_by'),
        accessor: 'createdUser',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.updatedUser}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_MODEL.CREATED_BY
      },
      {
        Header: t('individual_model_mng.updated_date'),
        accessor: 'updatedDt',
        Cell: ({ row: { original } }) => {
          return (
            <div>
              {original.updatedDt ? moment(original.updatedDt).format(DATE_FORMAT.full_time) : NO_DATE}
            </div>
          );
        },
        width: TABLE_ROW_WIDTH_MODEL.UPDATED_DATE
      },
      {
        Header: t("individual_model_mng.remove"),
        id: 'action',
        className: 'admin-action',
        Cell: ({ row: { original: { id } } }) => {
          return <div>
            <button className="btn btn-danger" type="button" onClick={() => this.openComfirmModal(id)}>
              {t('individual_model_mng.remove')}
            </button>
          </div>
        },
        width: 100,
      }
    ];
    return (
      <div className="screen-model">
        <ContainerBox headerTitle={`${t('individual_model_mng.page_title')}`} className="admin-body-container table-container">
          <div className="box-body document-item-info">
            <Table
              columns={columns}
              data={models}
              disablePaging={false}
              onFetch={this.onFetch}
              enableServerSidePaging={true}
              initialTableState={paging}
            />
          </div>
        </ContainerBox>
      </div>
    );
  }

}

export default withRouter(withTranslation()(ScreenIndividualModel));
